import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../constant";
import {
  portalLoginSuccess,
  portalLogout,
  selectActivePortalSubdomain,
  selectPortalAccessToken,
} from "../slice/portalAuthSlice";

const getSubdomainFromPath = () => {
  const match = window?.location?.pathname?.match(/^\/portal\/([^/]+)/);
  return match ? match[1] : null;
};

const rawBaseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  credentials: "include",
  prepareHeaders: (headers, { getState, extra }) => {
    const subdomain =
      extra?.subdomain || selectActivePortalSubdomain(getState()) || getSubdomainFromPath();
    const token = selectPortalAccessToken(getState(), subdomain);
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithPortalReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (
    result.error &&
    result.error.status === 401 &&
    result.error.data?.code === "token_not_valid"
  ) {
    const state = api.getState();
    const subdomain =
      extraOptions?.subdomain || selectActivePortalSubdomain(state) || getSubdomainFromPath();

    if (subdomain) {
      // Try to get a new token by calling refresh
      const refreshResult = await rawBaseQuery(
        {
          url: "/api/portal/v1/auth/refresh/",
          method: "POST",
          body: { subdomain },
        },
        api,
        extraOptions,
      );

      if (refreshResult.data) {
        // Store the new token
        const currentSession = state.portalAuth?.sessions?.[subdomain] || {};
        api.dispatch(
          portalLoginSuccess({
            subdomain,
            accessToken: refreshResult.data.portal_access_token,
            user: currentSession.user,
            portalId: currentSession.portalId,
          }),
        );
        // Retry the initial query
        result = await rawBaseQuery(args, api, extraOptions);
      } else {
        // Refresh failed, logout portal user
        api.dispatch(portalLogout({ subdomain }));
      }
    }
  }

  return result;
};

export const portalCustomerApiSlice = createApi({
  reducerPath: "portalCustomerApi",
  baseQuery: baseQueryWithPortalReauth,
  tagTypes: ["PortalCatalogue", "PortalCart", "PortalOrders"],
  endpoints: () => ({}),
});
